export default __webpack_public_path__ + "static/media/megamog.e634d01d.png";